import { Component, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ShareUrlComponent } from '../../modals/share-url/share-url.component';

@Component({
  selector: 'eng-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  private readonly modalService = inject(NgbModal);

  currentYear = new Date().getFullYear();

  public openShareModal() {
    this.modalService.open(ShareUrlComponent, { centered: true });
  }
}
